import React from 'react';
import { ModalWithStyles } from './ModalWithStyles';

interface IConfirmAgentPowerlists {
  handleClose: () => void;
  handleSubmit: () => void;
  show: boolean;
  title?: string;
  message?: React.ReactNode;
}

export function ConfirmAgentPowerlists({
  handleClose,
  handleSubmit,
  show,
  title = 'Disallow Agent Powerlists',
  message = (
    <>
      <p>
        All agent created powerlists will be deactivated and cannot be
        reactivated until this flag is set back to active.
      </p>
      <p> Do you want to continue?</p>
    </>
  ),
}: IConfirmAgentPowerlists) {
  return (
    <form className="form form-label-right" noValidate>
      <ModalWithStyles
        title={title}
        aria-labelledby="example-modal-sizes-title-md"
        show={show}
        onHide={handleClose}
        onSubmit={handleSubmit}
        size="xs"
        deleteDialog={false}
        submitLabel="Continue"
      >
        {message}
      </ModalWithStyles>
    </form>
  );
}
